import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { pdfPreviewAtom } from '../atom';

export function usePdfPreviewService() {
  const [config, setConfig] = useAtom(pdfPreviewAtom);

  const openPreview = useCallback((src: string, name?: string) => setConfig({ open: true, src, name }), [setConfig]);

  const closePreview = useCallback(() => setConfig(null), [setConfig]);

  return { config, openPreview, closePreview };
}
